export const esHero = {
  badge: 'Plataforma de pedidos empresarial',
  title_part1: 'Toma el control de tus',
  title_part2: ' pedidos en línea',
  subtitle:
    'Lewouhmart unifica catálogo de productos, inventario, pagos y envíos en una plataforma segura y lista para operar en varios países.',
  cta_primary: 'Empezar',
  cta_secondary: 'Ver demo',
  feature_iam_title: 'Identidad y seguridad',
  feature_iam_body:
    'Acceso basado en roles, MFA para empleados y seguridad transaccional por diseño.',
  feature_global_title: 'Listo para el mundo',
  feature_global_body:
    'Soporte multi-idioma y multi-moneda desde el primer día.',
  feature_stock_title: 'Inventario confiable',
  feature_stock_body:
    'Control de stock seguro bajo concurrencia con cálculo preciso de beneficios.',
  carousel_section_label: 'Aspectos destacados de la plataforma',
  carousel_iam_title: 'IAM seguro para todo tu equipo',
  carousel_iam_subtitle:
    'Los empleados inician sesión con MFA y acceso basado en roles, mientras que los clientes usan un simple flujo de correo + contraseña.',
  carousel_global_title: 'Listo para el mundo desde el primer día',
  carousel_global_subtitle:
    'Atiende a clientes en varios idiomas y monedas, con preferencias que viajan entre dispositivos.',
  carousel_stock_title: 'Inventario y cumplimiento fiables',
  carousel_stock_subtitle:
    'El control de stock seguro y el seguimiento de envíos mantienen tus operaciones precisas y predecibles.',
} as const;

export const esAuth = {
  tab_sign_in: 'Iniciar sesión',
  tab_register: 'Crear cuenta',
  sign_in_title: 'Inicia sesión en Lewouhmart',
  sign_in_subtitle:
    'Usa tu correo y contraseña para acceder a tus pedidos y la configuración de tu cuenta.',
  sign_in_customer_hint:
    'Inicia sesión con el correo y la contraseña de tu cuenta de cliente.',
  register_title: 'Crea tu cuenta de cliente',
  register_subtitle:
    'Utiliza tu correo y una contraseña segura. Te pediremos verificar tu correo en el primer inicio de sesión.',
  email_label: 'Correo electrónico',
  password_label: 'Contraseña',
  password_placeholder: 'Al menos 8 caracteres',
  sign_in_button: 'Continuar',
  register_button: 'Crear cuenta',
  register_invite_applied:
    'Te registras con el código de referidos {{code}}. La elegibilidad se comprueba cuando completes tu primera compra cualificada pagada.',
  register_invite_code_label: 'Código de referidos (opcional)',
  register_invite_code_placeholder: 'Código de invitación',
  register_invite_code_hint:
    'Déjalo en blanco si no tienes. Un código en el enlace de invitación (?ref=…) se aplica automáticamente.',
  register_apply_referral_checkbox: 'Usar un código de referidos',
  register_referral_required_when_checked:
    'Introduce un código de referidos o desmarca la casilla para continuar sin código.',
  mfa_title: 'Introduce tu código de seguridad',
  mfa_body_intro: 'Enviamos un código de 6 dígitos a',
  mfa_body_outro: 'Introdúcelo para finalizar el inicio de sesión.',
  mfa_button: 'Verificar y continuar',
  mfa_resend: 'Reenviar código',
  mfa_resend_sending: 'Enviando…',
  mfa_resend_wait: 'Reenviar código en {{seconds}}s',
  mfa_resend_failed: 'No se pudo reenviar el código.',
  mfa_back_to_sign_in: 'Volver al inicio de sesión',
  mfa_resend_policy:
    'Puedes reenviar el código hasta 3 veces por hora. Si el correo no llega, revisa spam o la configuración de correo del servidor (SES).',
  signed_in_title: 'Has iniciado sesión',
  signed_in_body:
    'Tus preferencias de idioma y moneda están sincronizadas con tu perfil. Futuras sesiones y otros clientes (como una app móvil) podrán reutilizarlas.',
  signed_in_label: 'Conectado como',
  signed_in_logout: 'Cerrar sesión',
  register_success_prefix: 'Cuenta creada para',
  register_success_suffix:
    'Te hemos enviado un correo de verificación. Por favor, confírmalo en tu bandeja de entrada antes de iniciar sesión.',
  register_success_banner_title: 'Revisa tu correo — un paso más',
  register_form_locked_note:
    'Este formulario queda bloqueado hasta que verifiques tu correo. Puedes cerrar esta pestaña después de abrir el mensaje que te enviamos.',
  verify_email_resent:
    'Tu correo aún no está verificado. Acabamos de enviarte otro correo de verificación. Por favor, confírmalo antes de intentarlo de nuevo.',
  verify_email_heading: 'Verifica tu correo electrónico',
  verify_email_loading: 'Verificando tu correo, por favor espera…',
  verify_email_success:
    'Tu correo ha sido verificado correctamente. Ahora puedes iniciar sesión.',
  verify_email_error:
    'No pudimos verificar tu correo. Es posible que el enlace haya expirado o ya se haya utilizado.',
  verify_email_missing_token:
    'El enlace de verificación no es válido. Usa el enlace de tu correo o solicita uno nuevo.',
  verify_email_back_to_signin: 'Volver a iniciar sesión',
  forgot_link: '¿Has olvidado tu contraseña?',
  forgot_title: 'Restablecer tu contraseña',
  forgot_subtitle:
    'Introduce tu correo y te enviaremos un enlace para restablecer tu contraseña.',
  forgot_submit: 'Enviar enlace de restablecimiento',
  forgot_sending: 'Enviando…',
  forgot_success:
    'Si existe una cuenta, se ha enviado un enlace de restablecimiento.',
  forgot_error: 'No se pudo enviar el correo de restablecimiento.',
  reset_title: 'Elige una nueva contraseña',
  reset_subtitle: 'Define una nueva contraseña para tu cuenta de Lewouhmart.',
  reset_password_label: 'Nueva contraseña',
  reset_confirm_password_label: 'Confirmar nueva contraseña',
  reset_submit: 'Guardar nueva contraseña',
  reset_saving: 'Guardando…',
  reset_mismatch: 'Las contraseñas no coinciden.',
  reset_invalid_link:
    'Este enlace de restablecimiento no es válido. Usa el enlace de tu correo.',
  reset_success:
    'Tu contraseña se ha actualizado. Ahora puedes iniciar sesión.',
  reset_error: 'No se pudo restablecer la contraseña.',
  reset_back_to_signin: 'Volver a iniciar sesión',
  account_deleted_notice:
    'Tu cuenta se ha eliminado. Lamentamos verte partir.',
  email_placeholder: 'tu@ejemplo.com',
  security_block_title: 'Seguridad de la cuenta',
  security_block_loading: 'Confirmando…',
  security_block_success:
    'Tu cuenta de equipo ha sido bloqueada. Las sesiones activas se cerraron. Contacta a un administrador si necesitas recuperar el acceso.',
  security_block_error_generic: 'Enlace no válido, ya usado o caducado.',
  security_block_missing_token: 'No se proporcionó ningún token de seguridad.',
  security_block_back_sign_in: 'Volver al inicio de sesión',
} as const;

export const esLayout = {
  app_name: 'Lewouhmart',
  app_tagline: 'Comercio y gestión de pedidos',
  footer_right:
    'Diseñado para la fiabilidad, la concurrencia y el crecimiento global.',
} as const;

export const esAccount = {
  title: 'Mi cuenta',
  subtitle:
    'Gestiona tu perfil, la seguridad del inicio de sesión y tu dirección de envío predeterminada.',
  sign_in_required: 'Inicia sesión para ver tu cuenta.',
  profile_section_title: 'Contacto y envío',
  profile_section_subtitle:
    'Se usa en pedidos, facturas y etiquetas de envío.',
  field_full_name: 'Nombre completo',
  field_phone: 'Teléfono',
  field_street: 'Dirección',
  field_city: 'Ciudad',
  field_postal_code: 'Código postal',
  field_country: 'País',
  readonly_name_label: 'Nombre',
  readonly_phone_label: 'Teléfono',
  readonly_address_label: 'Dirección',
  not_set: 'No definido',
  save_button: 'Guardar cambios',
  cancel_button: 'Cancelar',
  edit_button: 'Editar',
  status_label: 'Estado',
  status_verified: 'Verificado',
  status_pending: 'Pendiente de verificación',
  email_label: 'Correo de la cuenta',
  load_error: 'No se pudo cargar la información de la cuenta.',
  save_success: 'Perfil actualizado correctamente.',
  save_error: 'No se pudo guardar el perfil.',
  security_section_title: 'Seguridad',
  current_password_label: 'Contraseña actual',
  new_password_label: 'Nueva contraseña',
  confirm_password_label: 'Confirmar nueva contraseña',
  password_mismatch: 'Las contraseñas no coinciden.',
  password_save_button: 'Actualizar contraseña',
  password_saving_label: 'Actualizando…',
  password_change_success: 'Contraseña actualizada correctamente.',
  password_change_error: 'No se pudo cambiar la contraseña.',
  password_open_button: 'Cambiar contraseña',
  delete_section_title: 'Cerrar cuenta',
  delete_section_intro:
    'Al eliminarla, pierdes el acceso a este perfil. Los registros de pedidos pueden conservarse por requisitos legales u operativos, pero dejarán de asociarse a ti.',
  delete_email_retention:
    'Para ayudar a prevenir fraude y abusos en referidos, conservamos indefinidamente una forma normalizada de tu correo. Si te registras de nuevo con el mismo correo, obtienes un perfil nuevo sin vínculo con pedidos o actividad de referidos anteriores.',
  delete_phrase_hint_before: 'Escriba exactamente:',
  delete_password_label: 'Contraseña actual (obligatoria)',
  delete_confirm_label: 'Escribe esta frase para confirmar',
  delete_confirm_placeholder: 'I-want-to-delete-account',
  delete_confirm_mismatch:
    'Escribe exactamente la frase I-want-to-delete-account.',
  delete_password_required: 'Introduce tu contraseña actual.',
  delete_submit: 'Eliminar mi cuenta',
  delete_submitting: 'Eliminando…',
  delete_error: 'No se pudo eliminar la cuenta. Revisa tu contraseña.',
  delete_success_redirect: 'Tu cuenta ha sido eliminada.',
  retention_offer_percent:
    'Si te quedas: {{percent}}% sobre el subtotal de productos de tu próximo pedido (una vez, en el pago).',
  retention_accepted_with_percent:
    'Gracias por quedarte. Tu próximo pedido incluirá un {{percent}}% de descuento único sobre el subtotal de productos, visible al pagar y en el recibo.',
  retention_banner_title: 'Descuento por quedarte activado',
  retention_banner_dismiss: 'Cerrar',
  retention_cancel: 'Cancelar',
  retention_email_cooldown_notice:
    'Esta dirección de correo usó recientemente la oferta de permanencia o el descuento único por borrado. La oferta no estará disponible hasta el {{date}} (UTC).',
  sidebar_overview: 'Cuenta',
  sidebar_orders: 'Pedidos',
  sidebar_referrals: 'Referidos',
  sidebar_security: 'Seguridad',
  sidebar_notifications: 'Notificaciones',
  orders_title: 'Mis pedidos',
  orders_subtitle: 'Consulta el estado y el historial de tus pedidos.',
  orders_search_placeholder: 'Buscar ID de pedido o artículo',
  orders_empty: 'Aún no hay pedidos.',
  orders_empty_filtered: 'Ningún pedido coincide con los filtros.',
  order_id: 'Pedido',
  payment_id: 'ID de pago',
  payment_id_none: '—',
  preorder_payments_heading: 'Pagos con tarjeta (prepedido)',
  preorder_deposit_payment_label: 'ID del cobro de depósito',
  preorder_balance_payment_label: 'ID del cobro del saldo',
  preorder_balance_payments_label: 'IDs de cobro del saldo',
  preorder_balance_payment_index: '{{n}}.',
  preorder_balance_payment_pending: 'Aún no cobrado (tras la liberación)',
  items: 'Artículos',
  eta: 'Entrega estimada',
  eta_days: '{{days}} días',
  delivery_window_from: 'Desde',
  delivery_window_until: 'Hasta',
  order_history: 'Historial del pedido',
  cancel_order: 'Cancelar pedido',
  order_collapsed_hint:
    'Pedido cerrado contraído. Expande para ver los detalles.',
  orders_pagination_info: 'Página {{page}} de {{totalPages}}',
  orders_load_error: 'No se pudieron cargar los pedidos.',
  orders_cancel_error: 'No se pudo cancelar el pedido.',
  order_receipt_download: 'Recibo (PDF)',
  order_receipt_error: 'No se pudo descargar el recibo.',
  order_event_update: 'Actualización',
  order_event_change: '{{from}} → {{to}}',
  saving_label: 'Guardando…',
  order_status_PENDING: 'Pendiente',
  order_status_PAID: 'Pagado',
  order_status_SHIPPED: 'Enviado',
  order_status_DELIVERED: 'Entregado',
  order_status_CLOSED: 'Cerrado',
  order_status_CANCELLED: 'Cancelado',
  order_status_UNREACHABLE: 'Inalcanzable',
  order_status_DAMAGED: 'Dañado',
  order_status_INVESTIGATING: 'En investigación',
  order_status_FAULT_EMPLOYEE: 'Fallo (empleado)',
  order_status_FAULT_CUSTOMER: 'Fallo (cliente)',
  order_status_RESHIP_PENDING: 'Reenvío pendiente',
  order_status_RESHIPPED: 'Reenviado',
  referrals_copied: '¡Copiado!',
  referrals_status_pending: 'Esperando pedido que cumpla requisitos',
  referrals_status_qualified: 'Completado',
  referrals_status_rejected: 'No elegible',
  referrals_signup_only_note:
    'Los enlaces y códigos de referidos se usan al crear la cuenta—no al pagar. Si te registraste con el enlace de un amigo, ya está vinculado a tu perfil; no lo vuelves a introducir en el pago.',
  referrals_pending_hint:
    'No hace falta que nadie lo apruebe. Cuando tu primer pedido esté pagado y cumpla el importe mínimo ({{min}} USD), la invitación se completará automáticamente. Nunca introduces un código de referido en la caja.',
  referrals_qualified_hint:
    'Tu referido está completo: te registraste con el enlace de un amigo y completaste un primer pedido elegible. Las cantidades mostradas son objetivos del programa—no se aplican como un campo extra al pagar. Cómo se entregan las recompensas (crédito, pago, etc.) lo decide la tienda; contacta con soporte si esperabas un descuento inmediato en el pedido.',
  referrals_rejected_hint:
    'No se pudo contar esta invitación. Contacta con soporte si tienes dudas.',
  referrals_subtitle_ended:
    'Este programa de referidos ya no acepta nuevos participantes. Tu historial aparece abajo.',
  referrals_program_ended_banner:
    'El programa de referidos ya no acepta nuevos participantes. Conservamos tu historial. Las invitaciones pendientes que empezaron antes del cierre pueden completarse cuando se pague un pedido que cumpla las reglas.',
  referrals_program_ended_no_new_links:
    'Los nuevos enlaces de invitación están desactivados. Este era tu código mientras el programa estuvo activo.',
  referrals_disabled: 'El programa de referidos no está activo en este momento.',
} as const;

export const esHeader = {
  brand_name: 'Lewouhmart',
  brand_tagline: 'Comercio y gestión de pedidos',
  nav_home: 'Inicio',
  nav_cart: 'Carrito',
  nav_admin_dashboard: 'Panel',
  nav_admin_employees: 'Empleados',
  nav_admin_customers: 'Clientes',
  nav_products: 'Productos',
  nav_products_catalog: 'Catálogo',
  nav_products_inventory: 'Inventario y compras',
  logged_in_as: 'Conectado como',
  account_button: 'Cuenta',
  logout_button: 'Cerrar sesión',
} as const;

export const esFooter = {
  copyright: 'Lewouhmart. Todos los derechos reservados.',
  footer_right:
    'Diseñado para la fiabilidad, la concurrencia y el crecimiento global.',
  workspace_internal: 'Área de equipo.',
  workspace_open_storefront: 'Sitio de clientes',
  customer_heading: 'Cliente',
  link_home: 'Inicio',
  link_products: 'Productos',
  link_cart: 'Carrito',
  link_track_orders: 'Seguir pedidos',
  link_feedback_complaints: 'Comentarios y reclamaciones',
  link_about: 'Sobre nosotros',
  link_cookie_settings: 'Configuración de cookies',
  ops_heading: 'Operaciones',
  link_employee_signin: 'Acceso empleados',
  ops_live_workflow: 'Flujo de pedidos en vivo',
  ops_incidents: 'Incidencias y resolución',
  ops_analytics: 'Análisis por país',
  support_heading: 'Soporte y legal',
  terms: 'Términos del servicio',
  privacy: 'Política de privacidad',
  storefront_tagline: 'Diseñado para pedidos fiables a escala.',
  storefront_about:
    'Plataforma global de pedidos, inventario y seguimiento de entregas para equipos de comercio.',
} as const;

export const esAdmin = {
  sidebar_overview: 'Resumen',
  sidebar_employees: 'Empleados',
  sidebar_customers: 'Clientes',
  sidebar_customer_archives: 'Cuentas eliminadas (archivo)',
  sidebar_products: 'Productos',
  sidebar_categories: 'Categorías',
  sidebar_inventory: 'Inventario',
  sidebar_hero: 'Carrusel de inicio',
  sidebar_landing_promotion: 'Promoción de inicio',
  sidebar_mail_routing: 'Remitentes de correo',
  sidebar_group_users: 'Usuarios',
  sidebar_group_products: 'Productos',
  sidebar_group_settings: 'Configuración',
  sidebar_group_site_settings: 'Configuración del sitio',
  sidebar_group_system: 'Configuración del sistema',
  sidebar_suppliers: 'Proveedores',
  suppliers_title: 'Proveedores',
  suppliers_subtitle:
    'Gestiona tus proveedores. Solo los empleados pueden crear y editar proveedores; los proveedores no inician sesión.',
  suppliers_search: 'Buscar por nombre, correo o teléfono',
  suppliers_active_only: 'Solo activos',
  suppliers_new: 'Nuevo proveedor',
  suppliers_hide_form: 'Ocultar formulario',
  suppliers_name: 'Nombre',
  suppliers_email: 'Correo',
  suppliers_phone: 'Teléfono',
  suppliers_country: 'País',
  suppliers_country_placeholder: 'Seleccionar un país',
  suppliers_city: 'Ciudad',
  suppliers_address: 'Dirección',
  suppliers_notes: 'Notas',
  suppliers_save: 'Guardar proveedor',
  suppliers_update: 'Actualizar proveedor',
  suppliers_loading: 'Cargando proveedores…',
  suppliers_empty: 'No se encontraron proveedores.',
  suppliers_col_name: 'Nombre',
  suppliers_col_email: 'Correo',
  suppliers_col_phone: 'Teléfono',
  suppliers_col_country: 'País',
  suppliers_col_city: 'Ciudad',
  suppliers_col_status: 'Estado',
  suppliers_status_active: 'Activo',
  suppliers_status_inactive: 'Inactivo',
  suppliers_edit: 'Editar',
  suppliers_activate: 'Activar',
  suppliers_deactivate: 'Desactivar',
  suppliers_load_error: 'No se pudieron cargar los proveedores.',
  suppliers_save_error: 'No se pudo guardar el proveedor.',
  suppliers_update_error: 'No se pudo actualizar el proveedor.',
  categories_title: 'Categorías',
  categories_subtitle: 'Gestionar las categorías de productos para la tienda y la página de inicio.',
  categories_count: 'categorías',
  categories_add: 'Añadir categoría',
  categories_name: 'Nombre',
  categories_slug: 'Slug (URL)',
  categories_slug_placeholder: 'ej. verduras',
  categories_description: 'Descripción',
  categories_sort_order: 'Orden',
  categories_list: 'Todas las categorías',
  categories_loading: 'Cargando…',
  categories_empty: 'Aún no hay categorías.',
  categories_active: 'Activo',
  categories_update: 'Actualizar',
  categories_create: 'Crear',
  categories_confirm_delete: '¿Eliminar esta categoría?',
  categories_yes: 'Sí',
  categories_no: 'No',
  categories_load_error: 'No se pudieron cargar las categorías.',
  categories_save_error: 'No se pudo guardar la categoría.',
  categories_delete_error: 'No se pudo eliminar la categoría.',
  categories_duplicate_slug:
    'Ya existe una categoría con este slug de URL. Cambia el slug o el nombre.',
  categories_duplicate_generic:
    'Ya existe una categoría con este nombre o slug de URL. Cambia los valores e inténtalo de nuevo.',
  categories_field_name_taken: 'Este nombre ya está en uso en otra categoría.',
  categories_field_slug_taken: 'Este slug de URL ya está en uso en otra categoría.',
  categories_unique_hint: 'El nombre y el slug de URL de cada categoría deben ser únicos.',
  hero_title: 'Carrusel de inicio',
  hero_subtitle: 'Gestionar las diapositivas de pantalla completa en la página de inicio pública.',
  hero_form_edit: 'Editar diapositiva',
  hero_form_new: 'Nueva diapositiva',
  hero_label_image: 'Imagen',
  hero_label_headline: 'Título',
  hero_label_subheadline: 'Subtítulo',
  hero_label_button_label: 'Texto del botón',
  hero_label_button_link: 'Enlace del botón',
  hero_label_sort_order: 'Orden',
  hero_label_active: 'Activo',
  hero_btn_clear: 'Limpiar',
  hero_btn_save: 'Guardar cambios',
  hero_btn_add_slide: 'Añadir diapositiva',
  hero_existing_slides: 'Diapositivas existentes',
  hero_loading: 'Cargando…',
  hero_empty: 'Aún no hay diapositivas. Crea la primera a la izquierda.',
  hero_order: 'orden',
  hero_button: 'Botón',
  hero_link: 'Enlace',
  hero_btn_edit: 'Editar',
  hero_active: 'Activo',
  hero_inactive: 'Inactivo',
  hero_btn_delete: 'Eliminar',
  hero_confirm_delete: '¿Eliminar esta diapositiva?',
  hero_error_headline: 'El título es obligatorio',
  hero_error_upload: 'Sube una imagen',
  hero_shop_now_default: 'Comprar',
  dashboard_title: 'Área de administración',
  dashboard_subtitle:
    'Supervisa a tu equipo y tu base de clientes desde un solo lugar.',
  dashboard_card_employees_title: 'Empleados',
  dashboard_card_employees_body:
    'Resumen de todas las cuentas del personal con MFA obligatorio.',
  dashboard_card_customers_title: 'Clientes',
  dashboard_card_customers_body:
    'Clientes registrados con correos electrónicos verificados.',
  dashboard_card_security_title: 'Seguridad',
  dashboard_card_security_body:
    'Los empleados se autentican siempre con un código adicional enviado por correo.',

  employees_title: 'Empleados',
  employees_subtitle:
    'Invita al personal a Lewouhmart y gestiona sus datos básicos.',
  employees_invite_title: 'Invitar nuevo empleado',
  employees_invite_email_label: 'Correo de trabajo',
  employees_invite_name_label: 'Nombre completo',
  employees_invite_role_label: 'Puesto',
  employees_invite_phone_label: 'Teléfono',
  employees_invite_type_label: 'Tipo de cuenta',
  employees_invite_type_employee: 'Empleado',
  employees_invite_type_admin: 'Administrador',
  employees_invite_type_shipping_agent: 'Agente de envíos',
  roles_select_placeholder: 'Seleccionar un rol',
  employees_invite_submit: 'Enviar invitación',
  employees_invite_sending: 'Enviando…',
  employees_invite_success: 'Se ha enviado un correo de invitación al empleado.',
  employees_invite_error: 'No se pudo enviar la invitación.',
  employees_table_title: 'Miembros del equipo',
  employees_table_loading: 'Cargando empleados…',
  employees_table_empty:
    'Todavía no hay empleados. Envía una invitación para empezar.',
  employees_table_col_name: 'Nombre',
  employees_table_col_email: 'Correo',
  employees_table_col_role: 'Rol',
  employees_table_col_status: 'Estado',
  employees_blocked_intrusion: 'Bloqueado (intrusión, autogestión)',
  employees_table_status_active: 'ACTIVO',

  customers_title: 'Clientes',
  customers_subtitle:
    'Filtra el directorio, ordena por gasto o número de pedidos y abre un cliente para ver perfil y pedidos.',
  customers_loading: 'Cargando clientes…',
  customers_empty: 'Ningún cliente coincide con los filtros.',
  customers_error: 'No se pudieron cargar los clientes.',
  customers_table_col_name: 'Nombre',
  customers_table_col_email: 'Correo',
  customers_table_col_phone: 'Teléfono',
  customers_table_col_status: 'Estado',
  customers_filter_section: 'Filtros',
  customers_filter_show: 'Mostrar filtros',
  customers_filter_hide: 'Ocultar filtros',
  customers_filter_collapsed_hint:
    'Filtros ocultos para ver la tabla con más claridad. Los criterios activos siguen aplicándose.',
  customers_filter_section_hint:
    'País y ciudad sugieren valores de los perfiles de clientes. Elige primero el país para acotar ciudades.',
  customers_suggest_loading: 'Cargando sugerencias…',
  customers_suggest_error:
    'No se pudieron cargar las sugerencias. Comprueba la conexión o inténtalo de nuevo.',
  customers_suggest_no_countries: 'Aún no hay países guardados en los perfiles de clientes.',
  customers_suggest_no_cities: 'Aún no hay ciudades guardadas en los perfiles de clientes.',
  customers_suggest_no_match: 'Ningún valor coincide con tus datos de clientes.',
  customers_filter_search: 'Buscar (nombre, correo, teléfono)',
  customers_filter_search_ph: 'Escribe para filtrar…',
  customers_filter_phone: 'Teléfono',
  customers_filter_phone_ph: 'Dígitos o prefijo +',
  customers_filter_country: 'País',
  customers_filter_country_ph: 'p. ej. España',
  customers_filter_city: 'Ciudad',
  customers_filter_city_ph: 'p. ej. Madrid',
  customers_filter_registered_from: 'Registrado desde',
  customers_filter_registered_to: 'Registrado hasta',
  customers_filter_apply: 'Aplicar filtros',
  customers_filter_reset: 'Restablecer',
  customers_sort_label: 'Ordenar por',
  customers_sort_created_desc: 'Registro más reciente',
  customers_sort_created_asc: 'Registro más antiguo',
  customers_sort_spend_desc: 'Mayor gasto total (USD)',
  customers_sort_spend_asc: 'Menor gasto total (USD)',
  customers_sort_orders_desc: 'Más pedidos',
  customers_sort_orders_asc: 'Menos pedidos',
  customers_col_orders: 'Pedidos',
  customers_col_spend: 'Gasto (USD)',
  customers_col_city: 'Ciudad',
  customers_col_country: 'País',
  customers_col_drive_time: 'Tiempo de ruta',
  customers_col_actions: 'Acciones',
  customers_open_detail: 'Ver',
  customer_archives_title: 'Cuentas eliminadas — archivo',
  customer_archives_subtitle:
    'Instantáneas inmutables al borrar la cuenta. Los pedidos siguen (sin cliente); abre un archivo para el JSON y enlaces a pedidos en vivo.',
  customer_archives_search_label: 'Buscar',
  customer_archives_search_ph: 'Correo normalizado o id de usuario anterior',
  customer_archives_search_submit: 'Buscar',
  customer_archives_empty: 'Aún no hay archivos de eliminación.',
  customer_archives_error: 'No se pudieron cargar los archivos.',
  customer_archives_col_deleted: 'Eliminado el',
  customer_archives_col_name: 'Nombre (instantánea)',
  customer_archives_col_email: 'Correo (normalizado)',
  customer_archives_col_former_id: 'Id de usuario anterior',
  customer_archives_col_orders: 'Pedidos (instantánea)',
  customer_archives_col_actions: 'Acciones',
  customer_archives_open: 'Abrir',
  customer_archives_page_range: '{{from}}–{{to}} de {{total}}',
  customer_archive_detail_back: 'Lista de archivos',
  customer_archive_detail_title: 'Archivo de eliminación',
  customer_archive_detail_subtitle:
    'Instantánea de cumplimiento al eliminar. Pedidos en vivo si tienes ORDER:READ.',
  customer_archive_detail_summary: 'Resumen',
  customer_archive_detail_trigger: 'Origen',
  customer_archive_detail_orders_live: 'Pedidos (en vivo)',
  customer_archive_detail_order_id: 'Id de pedido',
  customer_archive_detail_batch: 'Lote de entrega',
  customer_archive_detail_open_order: 'Abrir en pedidos',
  customer_archive_detail_snapshot_json: 'Instantánea completa (JSON)',
  customer_archive_detail_snapshot_hint:
    'Perfil, ids de pedido, referidos, encuesta de salida, vistas previas.',
  customer_archive_detail_not_found: 'Archivo no encontrado.',
  customer_archive_detail_error: 'No se pudo cargar el archivo.',
  customers_total_count: '{{count}} clientes',
  customers_page_range: '{{from}}–{{to}} de {{total}}',
  customers_page_of: 'Página {{page}} / {{pages}}',
  customers_page_prev: 'Anterior',
  customers_page_next: 'Siguiente',
  customers_rows_per_page: 'Filas por página',
  customers_page_showing: 'Página {{page}} / {{pages}}',
  customers_detail_back: 'Volver a clientes',
  customers_detail_loading: 'Cargando cliente…',
  customers_detail_error: 'No se pudo cargar el cliente.',
  customers_detail_not_found: 'Cliente no encontrado.',
  customers_detail_total_spend: 'Gasto total',
  customers_detail_orders: 'pedidos',
  customers_detail_profile: 'Perfil',
  customers_detail_id: 'ID de cliente',
  customers_detail_address: 'Dirección',
  customers_detail_lat_lng: 'Lat / Lng',
  customers_detail_drive_time: 'Tiempo de ruta (tienda → dirección)',
  customers_detail_drive_status: 'Estado de ruta',
  customers_detail_created: 'Creado',
  customers_detail_last_login: 'Último acceso',
  customers_detail_preferences: 'Preferencias',
  customers_detail_order_summary: 'Resumen de pedidos',
  customers_detail_last_order: 'Último pedido',
  customers_detail_status_counts: 'Recuento por estado',
  customers_detail_orders_section: 'Pedidos',
  customers_detail_no_orders: 'Este cliente aún no tiene pedidos.',
  sidebar_account_deletion_retention: 'Retención al borrar cuenta',
  customers_detail_account_lifecycle: 'Borrado de cuenta y retención',
  customers_detail_account_lifecycle_hint:
    'Registro de retención del correo, archivos de borrado (incl. encuesta) e intentos recientes del flujo de borrado para esta cuenta.',
  customers_detail_retained_email_title: 'Correo retenido',
  customers_detail_delete_count: 'Borrados anteriores (este correo)',
  customers_detail_first_seen: 'Primera retención',
  customers_detail_last_deleted: 'Último borrado el',
  customers_detail_archives: 'Archivos de borrado',
  customers_detail_archive_deleted_at: 'Borrado',
  customers_detail_exit_survey: 'Encuesta de salida',
  customers_detail_exit_reasons: 'Motivos seleccionados',
  customers_detail_exit_comment: 'Comentario',
  customers_detail_recent_attempts: 'Intentos recientes de borrado',
  customers_detail_attempt_kind: 'Tipo',
  customers_detail_attempt_at: 'Cuándo',
  account_deletion_retention_title: 'Borrado de cuenta y retención',
  account_deletion_retention_blurb:
    'Configura la oferta de permanencia al borrar la cuenta, límites contra abusos y la encuesta cuando se supera el tope de ofertas.',
  account_deletion_retention_load_error:
    'No se pudieron cargar los ajustes de retención al borrar cuenta.',
  account_deletion_retention_saved: 'Ajustes de retención guardados.',
  account_deletion_retention_save_error: 'No se pudieron guardar los ajustes.',
  account_deletion_retention_enabled: 'Activar flujo de retención',
  account_deletion_retention_window_days: 'Ventana móvil (días)',
  account_deletion_retention_window_days_hint:
    'Las vistas previas en esta ventana cuentan para el límite de ofertas.',
  account_deletion_retention_max_offers: 'Máx. ofertas de retención por ventana',
  account_deletion_retention_max_offers_hint:
    'Tras tantas vistas previas en la ventana, se oculta la oferta y la encuesta es obligatoria.',
  account_deletion_retention_offer_title: 'Título de la oferta',
  account_deletion_retention_offer_body: 'Texto de la oferta',
  account_deletion_retention_promo_code: 'Código promocional opcional',
  account_deletion_retention_promo_hint:
    'Se muestra al cliente; debe existir en Promociones para aplicarse automáticamente.',
  account_deletion_retention_exit_reasons: 'Motivos de la encuesta de salida',
  account_deletion_retention_add_reason: 'Añadir motivo',
  account_deletion_retention_exit_reasons_hint:
    'Si se supera el tope, el cliente debe elegir motivos antes de borrar.',
  account_deletion_retention_label: 'Etiqueta',
  account_deletion_retention_discount_percent: 'Descuento único de permanencia (% del subtotal)',
  account_deletion_retention_discount_percent_hint:
    'Se aplica una vez en el siguiente pedido tras aceptar la oferta (queda registrado en el pedido para finanzas).',
  account_deletion_retention_email_cooldown_days: 'Enfriamiento por correo (días)',
  account_deletion_retention_email_cooldown_days_hint:
    'Tras aceptar la oferta o usar el descuento único, la oferta de retención queda bloqueada para ese correo durante este tiempo (aunque borre la cuenta y vuelva a registrarse). Use 0 para desactivar.',
  orders_discount_retention: 'Retención de cuenta (oferta de permanencia)',
  customers_detail_col_id: 'ID',
  customers_detail_col_date: 'Fecha',
  customers_detail_col_total: 'Total',
  customers_detail_col_city: 'Ciudad',
  customers_detail_items_count: '{{count}} artículos',
  employees_action_enable: 'Activar',
  employees_action_disable: 'Desactivar',
  employees_status_error: 'No se pudo actualizar el estado del empleado.',
  sidebar_roles: 'Roles',
  employees_table_col_roles: 'Roles',
  employees_roles_manage: 'Gestionar roles',
  employees_roles_modal_title: 'Asignar roles',
  employees_roles_load_error: 'No se pudieron cargar los roles.',
  employees_roles_save_error: 'No se pudieron actualizar los roles.',

  roles_title: 'Roles y permisos',
  roles_subtitle: 'Crea roles y asigna permisos detallados para cada función.',
  roles_list_title: 'Roles',
  roles_new: 'Nuevo rol',
  roles_field_name: 'Nombre del rol',
  roles_name_placeholder: 'p. ej. CONTABLE',
  roles_field_description: 'Descripción',
  roles_description_placeholder: 'Descripción corta',
  roles_create: 'Crear rol',
  roles_manage: 'Gestionar',
  roles_badge_system: 'Sistema',
  roles_col_name: 'Nombre',
  roles_col_description: 'Descripción',
  roles_col_permissions: 'Permisos',
  roles_col_users: 'Usuarios',
  roles_empty: 'Aún no hay roles.',
  roles_load_error: 'No se pudieron cargar los roles.',
  roles_create_error: 'No se pudo crear el rol.',
  roles_manage_title: 'Gestionar rol',
  roles_group_help: 'Selecciona lo que este rol puede hacer en esta sección.',
  roles_group_select_all: 'Seleccionar todo',
  roles_group_clear: 'Limpiar',
  roles_group_all: 'Todo',
  roles_group_some: 'Algunos',
  roles_group_none: 'Ninguno',
  roles_perm_catalog_error: 'No se pudo cargar el catálogo de permisos.',
  roles_perm_load_error: 'No se pudieron cargar los permisos del rol.',
  roles_perm_save_error: 'No se pudieron guardar los permisos.',
  roles_perm_save_success: 'Permisos guardados.',
  // Catálogo / productos
  products_title: 'Productos y catálogo',
  products_subtitle:
    'Gestiona los productos, precios e imágenes que alimentan tu tienda.',
  products_search_placeholder: 'Buscar por nombre o SKU',
  products_search_button: 'Buscar',
  products_search_clear: 'Limpiar',
  products_add_button: 'Añadir producto',
  products_hide_form: 'Ocultar formulario',
  products_name_label: 'Nombre',
  products_description_label: 'Descripción',
  products_image_label: 'URL de la imagen',
  products_unit_label: 'Unidad base',
  products_unit_lb: 'Libra (lb)',
  products_unit_kg: 'Kilogramo (kg)',
  products_price_label: 'Precio por unidad',
  products_delivery_fee_label: 'Tarifa fija de envío (opcional)',
  products_saving: 'Guardando…',
  products_update_button: 'Actualizar producto',
  products_create_button: 'Crear producto',
  products_table_title: 'Catálogo de productos',
  products_loading: 'Cargando productos…',
  products_empty:
    'Todavía no hay productos. Crea tu primer producto arriba.',
  products_table_col_name: 'Nombre',
  products_table_col_sku: 'SKU',
  products_table_col_category: 'Categoría',
  products_table_col_price: 'Precio / unidad',
  products_table_col_sale_price: 'Precio de oferta',
  products_table_col_stock: 'Stock (lb)',
  products_prev_page: 'Anterior',
  products_next_page: 'Siguiente',
  products_action_edit: 'Editar',
  // Inventario y compras
  inventory_title: 'Inventario y control de stock',
  inventory_subtitle:
    'Controla los lotes de stock, fechas de caducidad e historial de compras con búsqueda y filtros rápidos.',
  inventory_tab_lots: 'Lotes de stock',
  inventory_tab_purchases: 'Historial de compras',
  inventory_search_button: 'Buscar',
  inventory_lots_search: 'Buscar por nombre de producto',
  inventory_lots_loading: 'Cargando lotes de stock…',
  inventory_lots_empty: 'No se encontraron lotes de stock.',
  inventory_lots_col_product: 'Producto',
  inventory_lots_col_batch: 'Lote',
  inventory_lots_col_purchased: 'Comprado (lb)',
  inventory_lots_col_remaining: 'Restante (lb)',
  inventory_lots_col_expiry: 'Caducidad',
  inventory_prev_page: 'Anterior',
  inventory_next_page: 'Siguiente',
  inventory_purchases_search: 'Buscar por proveedor o referencia',
  inventory_purchases_from: 'Desde',
  inventory_purchases_to: 'Hasta',
  inventory_purchases_loading: 'Cargando compras…',
  inventory_purchases_empty:
    'No se encontraron compras para los filtros seleccionados.',
  inventory_purchases_col_date: 'Fecha',
  inventory_purchases_col_supplier: 'Proveedor',
  inventory_purchases_col_ref: 'Referencia',
  inventory_purchases_col_items: 'Artículos',
  inventory_purchases_col_total: 'Total',

  // Budget
  budget_title: 'Presupuesto',
  budget_subtitle: 'Defina períodos presupuestarios. Compras, pérdidas y otros gastos se deducen automáticamente.',
  budget_periods: 'Períodos presupuestarios',
  budget_new: 'Nuevo período',
  budget_name: 'Nombre del período',
  budget_initial: 'Importe inicial',
  budget_create: 'Crear',
  budget_loading: 'Cargando…',
  budget_empty: 'Aún no hay períodos presupuestarios.',
  budget_overbudget: 'Exceso de presupuesto',
  budget_hide_detail: 'Ocultar detalle',
  budget_view_detail: 'Ver detalle',
  budget_activate: 'Activar',
  budget_close: 'Cerrar',
  budget_balance: 'Saldo',
  budget_adjustment: 'Ajuste (+/-)',
  budget_description: 'Descripción',
  budget_add_adjustment: 'Añadir ajuste',
  budget_expense_amount: 'Importe del gasto',
  budget_expense_desc: 'ej. Servidores, anuncios',
  budget_add_expense: 'Añadir gasto',
  budget_type: 'Tipo',
  budget_amount: 'Importe',
  budget_date: 'Fecha',
  budget_entry_type_initial: 'Inicial',
  budget_entry_type_adjustment: 'Ajuste',
  budget_entry_type_purchase: 'Compra',
  budget_entry_type_loss: 'Pérdida',
  budget_entry_type_expense_other: 'Otro gasto',

  // Losses
  losses_title: 'Registrar pérdidas',
  losses_subtitle: 'Registre pérdidas de productos (caducados, dañados, perdidos). Se deduce del stock y del presupuesto activo.',
  losses_history: 'Historial de pérdidas',
  losses_record: 'Registrar pérdida',
  losses_product: 'Producto',
  losses_search_product: 'Buscar producto',
  losses_lot: 'Lote (opcional)',
  losses_quantity: 'Cantidad (lb)',
  losses_reason: 'Motivo',
  losses_notes: 'Notas',
  losses_submit: 'Registrar pérdida',
  losses_col_date: 'Fecha',
  losses_col_product: 'Producto',
  losses_col_lot: 'Lote',
  losses_col_qty: 'Cant. (lb)',
  losses_col_value: 'Valor',
  losses_col_reason: 'Motivo',
  losses_col_notes: 'Notas',
  losses_empty: 'Aún no hay pérdidas registradas.',
  losses_total_value: 'Valor total de pérdidas',
  losses_filtered: 'filtrado',
  losses_filter_by_reason: 'Filtrar por motivo',
  losses_all_reasons: 'Todos los motivos',
  losses_from_date: 'Desde fecha',
  losses_to_date: 'Hasta fecha',
  losses_clear_filters: 'Borrar filtros',
  loss_reason_expired: 'Caducado',
  loss_reason_damaged: 'Dañado',
  loss_reason_lost: 'Perdido',
  loss_reason_theft: 'Robo',
  loss_reason_other: 'Otro',

  sidebar_payments: 'Pagos',
  sidebar_promotions: 'Promociones',
  sidebar_referrals: 'Referidos',
  referrals_stat_pending: 'Pendientes',
  referrals_stat_qualified: 'Cualificados',
  referrals_stat_rejected: 'Rechazados',
  referrals_stat_codes: 'Códigos emitidos',
  referrals_stat_signup_sessions: 'Sesiones de alta',
  referrals_stat_checkout_queue: 'Cola de pago',
  referrals_deactivated_wind_down:
    'Programa desactivado para nuevos enlaces y altas sin sesión guardada. En curso: {{pending}} referido(s) pendiente(s), {{intents}} sesión(es) de registro (48 h), {{checkout}} pedido(s) sin pagar con descuento de bienvenida por referido.',
  referrals_wind_down_explainer:
    'Los enlaces públicos nuevos están desactivados. Quienes ya abrieron el registro con referido (sesión 48 h) pueden terminar. Los invitados con primer pedido pendiente conservan el descuento hasta pagar o cancelar.',
  payments_title: 'Pagos',
  payments_subtitle:
    'Pagos con tarjeta Stripe: cliente, pedido, importe, estado y metadatos seguros (marca, últimos 4). No guardamos el PAN completo.',
  payments_load_error: 'No se pudieron cargar los pagos.',
  payments_filter_search: 'Buscar',
  payments_filter_search_ph: 'Pedido, intent, email, last4…',
  payments_filter_status: 'Estado Stripe',
  payments_filter_from: 'Desde',
  payments_filter_to: 'Hasta',
  payments_apply: 'Aplicar',
  payments_col_date: 'Fecha',
  payments_col_customer: 'Cliente',
  payments_customer_deleted_badge: 'Cuenta eliminada',
  payments_customer_deleted_hint:
    'El historial de pagos se conserva. El perfil se quitó al eliminar la cuenta; el correo puede venir del recibo Stripe o del pedido.',
  payments_col_order: 'Pedido',
  payments_col_order_id: 'ID pedido',
  payments_col_payment_id: 'ID pago',
  payments_expand_order_id: 'ID pedido',
  payments_expand_payment_id: 'ID pago',
  payments_col_amount: 'Importe',
  payments_col_amount_tooltip:
    'Importe de este cobro convertido a USD (base del backoffice). En pre-pedidos, use Pedido (USD) para total, depósito y saldo pendiente.',
  payments_col_order_balance: 'Pedido (USD)',
  payments_order_total_short: 'Total',
  payments_order_deposit_short: 'Depósito',
  payments_order_remaining_short: 'Pendiente',
  payments_col_status: 'Estado',
  payments_col_card: 'Tarjeta',
  payments_col_type: 'Tipo',
  payments_empty: 'No hay pagos.',
  payments_view: 'Detalles',
  payments_pci_note:
    'Los datos sensibles los tokeniza Stripe. Esta pantalla solo muestra campos seguros tras el pago.',
  payments_detail_title: 'Registro de pago',
  payments_detail_error: 'No se pudo cargar el detalle del pago.',

  sidebar_group_security: 'Seguridad',
  sidebar_activities: 'Registro de actividad',
  activities_title: 'Registro de actividad',
  activities_subtitle:
    'Pista de auditoría para inicios de sesión, eventos de seguridad y acciones internas. Filtra por fechas, IP, IDs de usuario, gravedad y texto libre.',
  activities_load_error: 'No se pudo cargar el registro de actividad.',
  activities_apply: 'Aplicar filtros',
  activities_clear: 'Borrar filtros',
  activities_filter_q: 'Buscar mensaje / categoría / acción',
  activities_filter_q_ph: 'ej. login, brute',
  activities_filter_category: 'Categoría (exacta)',
  activities_filter_action: 'Acción (contiene)',
  activities_filter_action_ph: 'ej. login.success',
  activities_filter_severity: 'Gravedad',
  activities_filter_from: 'Desde fecha',
  activities_filter_to: 'Hasta fecha',
  activities_filter_actor: 'ID usuario actor',
  activities_filter_target: 'ID usuario objetivo',
  activities_filter_ip: 'IP (exacta)',
  activities_filter_ip_contains: 'IP (contiene)',
  activities_filter_subject_type: 'Tipo de asunto',
  activities_filter_subject_id: 'ID de asunto',
  activities_page_size: 'Filas por página',
  activities_col_time: 'Hora',
  activities_col_severity: 'Gravedad',
  activities_col_category: 'Categoría',
  activities_col_action: 'Acción',
  activities_col_actor: 'Actor',
  activities_col_ip: 'IP',
  activities_col_message: 'Mensaje',
  activities_empty: 'No hay actividades que coincidan con los filtros.',
  activities_pagination_info: 'Página {{page}} de {{totalPages}} · {{total}} eventos',
  activities_detail_ids: 'Identificadores',
  activities_detail_request: 'Solicitud',
  activities_detail_metadata: 'Metadatos (JSON)',

  promotions_title: 'Promociones',
  promotions_subtitle:
    'Crea códigos de descuento para el checkout. Restringe por cliente, gasto acumulado o subtotal mínimo.',
  promotions_load_error: 'No se pudieron cargar las promociones.',
  promotions_empty: 'Aún no hay promociones.',
  promotions_col_code: 'Código',
  promotions_col_type: 'Tipo',
  promotions_col_value: 'Valor',
  promotions_col_restricted: 'Solo cuenta',
  promotions_col_expires: 'Caduca',
  promotions_col_active: 'Activa',
  promotions_col_actions: 'Acciones',
  promotions_type_percent: 'Porcentaje',
  promotions_type_fixed: 'Importe fijo USD',
  promotions_unlimited: '—',
  promotions_deactivate: 'Desactivar',
  promotions_create_open: 'Nueva promoción',
  promotions_form_code: 'Código',
  promotions_form_description: 'Descripción (interna)',
  promotions_form_discount_type: 'Tipo de descuento',
  promotions_form_percent: 'Porcentaje (0–100)',
  promotions_form_fixed: 'Descuento fijo (USD)',
  promotions_form_restricted_customer: 'Restringir al correo del cliente (opcional)',
  promotions_form_restricted_ph: 'cliente@ejemplo.com',
  promotions_form_restricted_hint:
    'Si se indica, solo la cuenta con ese correo puede canjear el código.',
  promo_seg_collapsed_sub:
    'Despliega para configurar filtros y buscar. También puedes crear códigos restringidos por correo sin buscar.',
  promo_seg_table_idle: 'Despliega los filtros arriba y pulsa Ejecutar búsqueda para cargar clientes.',
  promotions_form_min_lifetime: 'Gasto mínimo acumulado USD (opcional)',
  promotions_form_min_subtotal: 'Subtotal mínimo USD (opcional)',
  promotions_form_max_total: 'Canjes máximos totales (opcional)',
  promotions_form_max_per_customer: 'Máx. por cliente (opcional)',
  promotions_form_expires: 'Caduca el (opcional, local)',
  promotions_form_active: 'Activa',
  promotions_save: 'Crear promoción',
  promotions_save_error: 'No se pudo guardar.',
  promotions_deactivate_error: 'No se pudo desactivar.',

  delivery_batches_title: 'Lotes de entrega',
  delivery_batches_subtitle:
    'Agrupa pedidos pagados por zona y ventana para las rutas. Mueve pedidos entre lotes hasta el envío.',
  delivery_batches_load_error: 'No se pudieron cargar los lotes.',
  delivery_batches_save_error: 'No se pudo guardar el lote.',
  delivery_batches_create: 'Nuevo lote',
  delivery_batches_area_label: 'Zona',
  delivery_batches_area_ph: 'p. ej. lote Nueva York',
  delivery_batches_name_optional: 'Nombre interno (opcional)',
  delivery_batches_country_optional: 'País (opcional)',
  delivery_batches_city_optional: 'Ciudad (opcional)',
  delivery_batches_window_start: 'Inicio de ventana',
  delivery_batches_window_end: 'Fin de ventana',
  delivery_batches_estimated_window: 'Ventana de entrega estimada',
  delivery_batches_notes_optional: 'Notas (opcional)',
  delivery_batches_save: 'Crear lote',
  delivery_batches_list: 'Lotes',
  delivery_batches_empty: 'Aún no hay lotes.',
  delivery_batches_select: 'Selecciona un lote para ver pedidos.',
  delivery_batches_detail_error: 'No se pudo cargar el lote.',
  delivery_batches_close: 'Marcar cerrado',
  delivery_batches_close_dispatch: 'Cerrar lote y marcar envíos',
  delivery_batches_close_confirm:
    '¿Cerrar este lote? Todos los pedidos pagados se enviarán en un trabajo en segundo plano (no en esta petición). Puedes irte y volver cuando quieras para ver el progreso.',
  delivery_batches_dispatching:
    'Trabajo en segundo plano… los pedidos pasan a ENVIADO. El lote se cerrará automáticamente al terminar.',
  delivery_batches_dispatch_progress: '{{processed}} / {{total}} pedidos procesados',
  delivery_batches_dispatch_background:
    'Puedes salir de esta página: el progreso se guarda. Vuelve a abrir este lote para ver el estado en vivo.',
  delivery_batches_dispatch_failed: 'Error en el envío. Detalles abajo.',
  delivery_batches_dispatch_partial_title: 'Algunos pedidos no pudieron enviarse:',
  delivery_batches_dispatch_notice:
    'Cierre en cola. Los pedidos pagados se marcarán ENVIADO en segundo plano.',
  delivery_batches_delete: 'Eliminar lote vacío',
  delivery_batches_delete_confirm: '¿Eliminar este lote? Solo si no tiene pedidos.',
  delivery_batches_orders_count: '{{count}} pedidos',
  delivery_batches_add_order: 'Asignar pedido pagado',
  delivery_batches_pick_order: 'Elegir pedido…',
  delivery_batches_assign: 'Asignar',
  delivery_batches_in_batch: 'Pedidos en este lote',
  delivery_batches_no_orders: 'No hay pedidos en este lote.',
  delivery_batches_speed: 'Tipo de entrega',
  delivery_batches_remove: 'Quitar del lote',
  delivery_batches_create_expand: 'Mostrar formulario',
  delivery_batches_create_collapse: 'Ocultar formulario',
  delivery_batches_search_hint:
    'Escribe país y/o ciudad (sugerencias de pedidos pagados) o palabras clave — resultados en vivo.',
  delivery_batches_searching: 'Buscando…',
  delivery_batches_assign_country: 'País',
  delivery_batches_assign_country_ph: 'p. ej. Estados Unidos',
  delivery_batches_assign_town: 'Ciudad / localidad',
  delivery_batches_assign_town_ph: 'p. ej. Nueva York',
  delivery_batches_order_search: 'Palabras clave (opcional)',
  delivery_batches_order_search_ph: 'Id de pedido, nombre, correo…',
  delivery_batches_search_required: 'Introduce al menos país, ciudad o palabra clave y pulsa Buscar.',
  delivery_batches_search_button: 'Buscar',
  delivery_batches_search_empty_prompt:
    'Empieza a escribir país, ciudad o palabra clave — búsqueda en vivo de pedidos pagados.',
  delivery_batches_select_all_results: 'Seleccionar todos en resultados',
  delivery_batches_select_all_area: 'Seleccionar todos en esta zona',
  delivery_batches_clear_selection: 'Borrar selección',
  delivery_batches_area_unknown: 'Dirección incompleta',
  delivery_batches_suggest_hint:
    'Haz clic en las filas para seleccionar. Los pedidos ya en este lote no se muestran.',
  delivery_batches_selected_n: '{{count}} seleccionado(s)',
  delivery_batches_assign_selected: 'Asignar selección',
  delivery_batches_other_batch: 'En: {{batch}}',
  delivery_batches_no_search_matches: 'Ningún pedido coincide.',
  sidebar_delivery_batches: 'Lotes de entrega',
  orders_delivery_speed: 'Entrega',
  orders_batch_label: 'Lote',
  orders_no_batch: 'Aún sin lote',
  orders_receipt_download: 'Recibo (PDF)',
  orders_receipt_error: 'No se pudo descargar el recibo.',
  orders_progress_title: 'Progreso del pedido',
  orders_progress_simple_subtitle: 'Preparación estándar',
  orders_progress_incident_badge: 'Flujo de incidencia y reembolso',
  orders_progress_main: 'Preparación y entrega',
  orders_progress_refund_step: 'Reembolso',
  orders_progress_branch: 'Incidencia y reenvío',
  orders_progress_issue: 'Incidencia',
  orders_progress_investigating: 'Investigación',
  orders_progress_resolution: 'Responsabilidad',
  orders_progress_reship_prep: 'Cola de reenvío',
  orders_progress_out_again: 'En ruta (reenvío)',
  orders_progress_merge_delivered: 'Luego a Entregado',
  orders_progress_unreachable_short: 'Inalcanzable',
  orders_progress_damaged_short: 'Dañado',
  orders_progress_fault_employee: 'Equipo',
  orders_progress_fault_customer: 'Cliente',
  orders_progress_refund_sidebar:
    'Reembolso o devolución en curso — el flujo puede no coincidir con el camino estándar.',
  orders_progress_delivered_skipped: 'n/a',
  incident_open_unreachable_confirm_title: 'Confirmar incidente inalcanzable',
  incident_open_unreachable_confirm_message:
    '¿Marcar este pedido como inalcanzable?',
  incident_open_unreachable_confirm_message_batched:
    'Este pedido está en el lote «{{batch}}». Se quitará del lote para gestionar esta entrega inalcanzable fuera de la ruta del lote. ¿Continuar?',
  incident_open_damaged_confirm_title: 'Confirmar incidente dañado',
  incident_open_damaged_confirm_message: '¿Marcar este pedido como dañado?',
  incident_open_damaged_confirm_message_batched:
    'Este pedido está en el lote «{{batch}}». Se quitará del lote para gestionar este envío dañado fuera de la ruta del lote. ¿Continuar?',

  sidebar_delivery_pricing: 'Precios de envío',
  delivery_pricing_title: 'Precios de envío',
  delivery_pricing_subtitle:
    'Elija el modo (peso o tiempo de ruta) y los tramos. El origen del tiempo de ruta usa las mismas coordenadas que Contacto público (al elegir la dirección). Los tiempos se calculan en segundo plano.',
  delivery_pricing_load_error: 'No se pudieron cargar los ajustes.',
  delivery_pricing_save_error: 'No se pudo guardar.',
  delivery_pricing_saved: 'Ajustes guardados.',
  delivery_pricing_store_section: 'Origen (tiempo de ruta)',
  delivery_pricing_store_public_contact_info:
    'Usamos las mismas coordenadas que Contacto público. Elija una dirección sugerida para guardar lat/lng; no hace falta repetirlo aquí.',
  delivery_pricing_store_edit_public_contact: 'Editar contacto público',
  delivery_pricing_store_resolved: 'Origen usado',
  delivery_pricing_store_source_public: 'Contacto público',
  delivery_pricing_store_source_override: 'Anulación manual',
  delivery_pricing_store_source_none: 'Sin coordenadas aún',
  delivery_pricing_store_no_coords_hint:
    'Abra Contacto público, país y ciudad, y elija una dirección de las sugerencias.',
  delivery_pricing_store_override_section: 'Opcional: coordenadas manuales',
  delivery_pricing_store_override_hint: 'Solo si el origen debe ser distinto del contacto público.',
  delivery_pricing_store_clear_override: 'Usar contacto público',
  delivery_pricing_clear_override_confirm:
    '¿Quitar la anulación y usar las coordenadas del contacto público?',
  delivery_pricing_store_set_override: 'Guardar anulación',
  delivery_pricing_latitude: 'Latitud',
  delivery_pricing_longitude: 'Longitud',
  delivery_pricing_label: 'Etiqueta (opcional)',
  delivery_pricing_mode_label: 'Modelo de precio',
  delivery_pricing_mode_weight: 'Por peso (heredado)',
  delivery_pricing_mode_driving: 'Tiempo de ruta (tienda → cliente)',
  delivery_pricing_weight_section: 'Tarifas por peso (reserva)',
  delivery_pricing_weight_base: 'Tarifa base (USD)',
  delivery_pricing_weight_per_lb: 'Por lb (USD)',
  delivery_pricing_express_surcharge: 'Recargo express (USD)',
  delivery_pricing_weight_days_standard: 'Días estándar (peso)',
  delivery_pricing_weight_days_express: 'Días express (peso)',
  delivery_pricing_driving_section: 'Tramos por tiempo de ruta',
  delivery_pricing_standard_days: 'Plazo estándar (días)',
  delivery_pricing_express_days: 'Plazo express (días)',
  delivery_pricing_tiers_hint:
    'Cada fila: minutos máx. (incl.) y tarifa USD. Ordenar por minutos; use un máximo alto en la última fila.',
  delivery_pricing_standard_tiers: 'Tramos estándar (JSON)',
  delivery_pricing_express_tiers: 'Tramos express (JSON)',
  delivery_pricing_recompute_all: 'Recalcular para todos los clientes',
  delivery_pricing_recompute_all_confirm: '¿Encolar a todos los clientes? Puede tardar.',
  delivery_pricing_recompute_all_done: '{{count}} trabajos encolados.',
  delivery_pricing_redis_hint:
    'Requiere Redis (BullMQ) y GOOGLE_MAPS_API_KEY con Routes API habilitada (no la Distance Matrix antigua).',
  delivery_pricing_readonly:
    'Solo lectura. Se necesita DELIVERY_PRICING:UPDATE (o admin) para editar.',

  delivery_pricing_rules_section: 'Reglas de precio (subtotal + peso + distancia + país)',
  delivery_pricing_express_enabled: 'Habilitar entrega express',
  delivery_pricing_store_country: 'País de la tienda (código ISO)',
  delivery_pricing_days_standard: 'Plazo estándar (días)',
  delivery_pricing_days_express: 'Plazo express (días)',
  delivery_pricing_countries_section: 'Países de destino',
  delivery_pricing_add_country: 'Añadir país',
  delivery_pricing_country_code: 'Código de país',
  delivery_pricing_country_express_enabled: 'Express habilitado para este país',
  delivery_pricing_border_fee: 'Tarifa de frontera (USD)',
  delivery_pricing_base_fee: 'Tarifa base (USD)',
  delivery_pricing_per_mile: 'Por milla (USD)',
  delivery_pricing_per_lb: 'Por lb (USD)',
  delivery_pricing_us_threshold_section: 'Umbral USA (gratis / tarifa fija)',
  delivery_pricing_free_min_subtotal: 'Subtotal mín. (USD)',
  delivery_pricing_free_max_weight: 'Peso máx. (lb)',
  delivery_pricing_free_fee: 'Tarifa si aplica (USD)',
  delivery_pricing_preview_title: 'Calculadora (vista previa)',
  delivery_pricing_preview_hint: 'Prueba números antes de guardar reglas.',
  delivery_pricing_preview_subtotal: 'Subtotal (USD)',
  delivery_pricing_preview_weight: 'Peso total (lb)',
  delivery_pricing_preview_miles: 'Distancia (millas)',
  delivery_pricing_preview_country: 'País de destino',
  delivery_pricing_preview_standard_fee: 'Tarifa estándar',
  delivery_pricing_preview_express_fee: 'Tarifa exprés',
  delivery_pricing_preview_express_unavailable: 'Exprés no disponible (desactivado globalmente o por país).',
  delivery_pricing_preview_threshold_applied: 'Umbral aplicado.',
  delivery_pricing_preview_invalid_country: 'Introduce un código de país (p. ej., US).',
  delivery_pricing_preview_country_missing: 'No hay regla configurada para {{country}}.',

  orders_col_order_id: 'ID de pedido',
  orders_col_total: 'Total',
  orders_preorder_card_payments_heading: 'Registros de pago con tarjeta',
  orders_preorder_deposit_payment: 'Depósito (primer cobro)',
  orders_preorder_balance_payment: 'Saldo (tras liberación)',
  orders_preorder_balance_payments_heading: 'Cobros de saldo (tras liberación)',
  orders_preorder_balance_payment_index: 'Cobro {{n}}',
  orders_preorder_balance_payment_pending:
    'Aún no hay cobro del saldo. El cliente paga el resto cuando liberes el prepedido.',
  orders_customer_account_deleted_banner:
    'Cuenta de cliente eliminada — pedido archivado para operaciones. Estado, lote, incidencias y reenvío desactivados. La verificación Stripe abajo sigue disponible para marcar un pago pendiente.',
  orders_customer_account_deleted_badge: 'Cuenta eliminada',
  orders_workflow_frozen_short: 'Archivado (sin flujo)',
  orders_view_scope: 'Vista de pedidos',
  orders_filters_label: 'Búsqueda y filtros',

  mail_routing_title: 'Remitentes de correo',
  mail_routing_subtitle:
    'Elige direcciones From y Reply-To por tipo de correo. Usa identidades verificadas en Amazon SES. La primera From se usa para cada uso; añade Reply-To no-reply si hace falta.',
  mail_routing_load_error: 'No se pudieron cargar los ajustes.',
  mail_routing_save_error: 'No se pudo guardar.',
  mail_routing_saved: 'Remitentes guardados.',
  mail_routing_hint:
    'Deja una sección vacía para usar SES_SOURCE_EMAIL y MAIL_DEFAULT_REPLY_TO del servidor. Puedes listar varias From; solo la primera se usa como remitente.',
  mail_routing_readonly:
    'Solo lectura: solo quien tenga «Configurar remitentes de correo» (MAIL_ROUTING:UPDATE) puede cambiar estos valores.',
  mail_routing_from: 'Direcciones From (una por línea)',
  mail_routing_from_help:
    'Deben estar verificadas en AWS SES. La primera dirección es el remitente.',
  mail_routing_reply_to: 'Reply-To (recomendado no-reply)',
  mail_routing_bcc: 'BCC (opcional, copias internas)',
  mail_routing_bcc_help:
    'Destinatarios en copia oculta del mismo mensaje (alertas internas, etc.).',
  mail_routing_save: 'Guardar remitentes',
  mail_routing_saving: 'Guardando…',

  mail_routing_purpose_EMAIL_VERIFICATION: 'Verificación de correo',
  mail_routing_purpose_PASSWORD_RESET: 'Restablecer contraseña',
  mail_routing_purpose_MFA_LOGIN_CODE: 'Código de acceso (MFA)',
  mail_routing_purpose_EMPLOYEE_INVITE: 'Invitación de empleado',
  mail_routing_purpose_WELCOME_CUSTOMER: 'Bienvenida (nuevo cliente)',
  mail_routing_purpose_ORDERS_CUSTOMER: 'Pedidos (cliente)',
  mail_routing_purpose_ORDERS_STAFF: 'Pedidos (equipo)',
  mail_routing_purpose_BUDGET_REPORT: 'Informes de presupuesto',
  mail_routing_purpose_EXPIRY_ALERT: 'Alertas de caducidad',
  mail_routing_purpose_GENERAL: 'Otro / predeterminado',
  mail_routing_purpose_REFERRAL: 'Programa de referidos (cliente)',
} as const;

export const esRbac = {
  perm_group: {
    catalog: 'Catálogo',
    inventory: 'Inventario',
    orders: 'Pedidos',
    payments: 'Pagos (Stripe)',
    finance: 'Finanzas',
    settings: 'Configuración',
    users: 'Usuarios',
    rbac: 'Control de acceso',
    security: 'Seguridad y auditoría',
  },
  perm_desc: {
    payment: {
      read:
        'Accede al área de Pagos: listado de cobros con tarjeta, búsqueda y filtros, y detalle (intent de Stripe, tarjeta, pedido vinculado).',
    },
  },
  perm: {
    product: {
      read: 'Leer productos',
      create: 'Crear productos',
      update: 'Actualizar productos',
      delete: 'Eliminar productos',
      upload: 'Subir imágenes de productos',
    },
    category: {
      read: 'Leer categorías',
      create: 'Crear categorías',
      update: 'Actualizar categorías',
      delete: 'Eliminar categorías',
    },
    supplier: {
      read: 'Leer proveedores',
      create: 'Crear proveedores',
      update: 'Actualizar proveedores',
      delete: 'Eliminar proveedores',
    },
    order: {
      read: 'Leer pedidos',
      update: 'Actualizar pedidos',
    },
    order_detail: {
      read: 'View order details',
    },
    order_incident: {
      read: 'View order incidents',
      update: 'Manage order incidents',
    },
    order_resolution: {
      read: 'View incident resolutions',
      update: 'Resolve order incidents',
    },
    order_reship: {
      create: 'Reship orders after employee fault',
    },
    order_stats: {
      read: 'View order analytics',
    },
    promotion: {
      read: 'Ver promociones',
      create: 'Crear promociones',
      update: 'Actualizar promociones',
      delete: 'Desactivar promociones',
    },
    referral: {
      read: 'Ver programa de referidos',
      update: 'Configurar referidos y correos de anuncio',
    },
    payment: {
      read: 'Ver el área de pagos Stripe',
    },
    mail_routing: {
      read: 'Ver remitentes de correo',
      update: 'Configurar remitentes de correo',
    },
    purchase: {
      read: 'Leer compras',
      create: 'Crear compras',
      update: 'Actualizar compras',
      delete: 'Eliminar compras',
    },
    purchase_order: {
      read: 'Leer órdenes de compra',
      create: 'Crear órdenes de compra',
      update: 'Actualizar órdenes de compra',
      delete: 'Eliminar órdenes de compra',
      complete: 'Completar órdenes de compra',
      print: 'Imprimir órdenes de compra',
    },
    stock_lot: {
      read: 'Leer lotes de stock',
      update: 'Actualizar lotes de stock',
    },
    loss: {
      read: 'Leer pérdidas',
      create: 'Registrar pérdidas',
    },
    budget_period: {
      read: 'Leer periodos de presupuesto',
      create: 'Crear periodos de presupuesto',
      update: 'Actualizar periodos de presupuesto',
      delete: 'Eliminar periodos de presupuesto',
    },
    budget_report: {
      create: 'Generar informes de presupuesto',
    },
    currency: {
      read: 'Leer monedas',
      update: 'Gestionar monedas',
    },
    ui_setting: {
      read: 'Ver la configuración de pantalla',
      update: 'Cambiar la configuración de pantalla',
    },
    expiry_alert: {
      read: 'Leer alertas de caducidad',
      update: 'Gestionar alertas de caducidad',
    },
    hero: {
      read: 'Leer hero',
      create: 'Crear hero',
      update: 'Actualizar hero',
      delete: 'Eliminar hero',
      upload: 'Subir imágenes hero',
    },
    employee: {
      read: 'Leer empleados',
      create: 'Crear empleados',
      update: 'Actualizar empleados',
    },
    customer: {
      read: 'Leer clientes',
    },
    delivery_pricing: {
      read: 'Ver ajustes de entrega',
      update: 'Configurar tarifas y ubicación de tienda',
    },
    role: {
      read: 'Leer roles',
      create: 'Crear roles',
      update: 'Actualizar roles',
      delete: 'Eliminar roles',
    },
    activity: {
      read: 'Ver registro de actividad de seguridad (auditoría, filtros IP)',
    },
  },
} as const;

export const esCommon = {
  save: 'Guardar',
  cancel: 'Cancelar',
  edit: 'Editar',
  delete: 'Eliminar',
  saving: 'Guardando…',
  empty_placeholder: '—',
  loading: 'Cargando…',
  list_loading_title: 'Cargando datos…',
  list_loading_hint:
    'Con una conexión lenta puede tardar un momento. Gracias por tu paciencia.',
  filter: 'Filtrar',
  clear: 'Borrar',
  all: 'Todos',
  prev: 'Anterior',
  next: 'Siguiente',
  remove: 'Quitar',
  collapse: 'Contraer',
  expand: 'Expandir',
  language: 'Idioma',
  currency: 'Moneda',
} as const;

export const esEmployee = {
  sidebar_profile: 'Perfil',
  sidebar_team: 'Equipo',
  sidebar_security: 'Seguridad',
  title: 'Perfil del equipo',
  subtitle:
    'Gestiona los datos de perfil de tu personal utilizados en el back office.',
  sign_in_required: 'Inicia sesión para ver tu perfil.',
  profile_section_title: 'Perfil del empleado',
  profile_section_subtitle:
    'Cómo aparecen tus datos en el back office.',
  field_full_name: 'Nombre completo',
  field_role_title: 'Rol / título',
  field_phone: 'Teléfono',
  edit_button: 'Editar',
  save_button: 'Guardar cambios',
  saving_label: 'Guardando…',
  cancel_button: 'Cancelar',
  readonly_name_label: 'Nombre',
  readonly_role_label: 'Rol / título',
  readonly_phone_label: 'Teléfono',
  not_set: 'No definido',
  load_error: 'No se pudo cargar el perfil.',
  save_success: 'Perfil actualizado correctamente.',
  save_error: 'No se pudo guardar el perfil.',
  account_email_label: 'Correo de la cuenta',
  account_role_label: 'Rol',
  security_section_title: 'Seguridad',
  current_password_label: 'Contraseña actual',
  new_password_label: 'Nueva contraseña',
  confirm_password_label: 'Confirmar nueva contraseña',
  password_mismatch: 'Las contraseñas no coinciden.',
  password_save_button: 'Actualizar contraseña',
  password_saving_label: 'Actualizando…',
  password_change_success: 'Contraseña actualizada correctamente.',
  password_change_error: 'No se pudo cambiar la contraseña.',
  password_open_button: 'Cambiar contraseña',
} as const;

export const esEmployeeInvite = {
  title: 'Completa tu invitación',
  subtitle:
    'Define una contraseña para tu cuenta de empleado de Lewouhmart. La próxima vez que inicies sesión, se enviará un código MFA a tu correo.',
  invalid_link:
    'Este enlace de invitación no es válido. Usa el enlace recibido por correo.',
  field_password_label: 'Elige una contraseña',
  field_password_confirm_label: 'Confirma la contraseña',
  password_mismatch: 'Las contraseñas no coinciden.',
  suggest_password: 'Sugerir una contraseña segura',
  saving_label: 'Guardando…',
  save_button: 'Guardar contraseña',
  back_to_signin: 'Volver a iniciar sesión',
  error_generic: 'No se pudo completar la invitación.',
  success_message:
    'Tu contraseña se ha establecido. Ahora puedes iniciar sesión.',
} as const;


